import React from 'react';

export const TrContext = React.createContext({
    hasDescription: false,
    setHasDescription: (value: boolean) => {},

    expanded: false,
    setExpanded: (value: boolean) => {},
});
